import { useTranslations } from 'next-intl';

import { FormattedMessage } from '@flipster/i18n';
import { Button } from '@flipster/react/design-system/button';
import { NoSSR } from '@flipster/react/misc/lifecycle/NoSSR';
import { css } from '@flipster/styled-system/css';
import { center } from '@flipster/styled-system/patterns';

import { zendesk } from '../shared/zendesk/url';
import MaintenanceImg from './assets/maintenance.webp';

const Maintenance = () => {
  const t = useTranslations();
  return (
    <div className={center({ height: '100vh', bg: 'background.default.level-0' })}>
      <div
        className={center({ flexFlow: 'column', maxWidth: '726px', textAlign: 'center', p: { base: 16, tablet: 0 } })}
      >
        <img
          src={MaintenanceImg.src}
          alt='maintenance'
          className={css({ w: '100%', maxW: 604, aspectRatio: '604/336' })}
        />
        <h1
          className={css({
            textStyle: 'Display/L',
            px: 12,
            mb: 16,
            mt: { base: 8, tablet: 20 },
            color: 'content.default.level-5',
            textWrap: 'balance',
          })}
        >
          <FormattedMessage id='Autogen_common.r251126.s_We_re_working_hard_to_serve_you_better' />
        </h1>
        <p
          className={css({
            textStyle: 'Text/L/Regular',
            px: 12,
            mb: { base: 30, tablet: 60 },
            color: 'content.default.level-1',
          })}
        >
          <FormattedMessage id='Autogen_common.r251126.s_Our_app_is_temporarily_unavailable_for_maintenance_We_appreciate_your_understanding_as_we_work_to_improve_your_experience_Thank_you_for_your_patience' />
        </p>
        <NoSSR>
          <Button
            hierarchy='primary'
            size='large'
            as='a'
            newTab
            href={zendesk.getUrl('RequestNew')}
            label={t('Autogen_common.r251126.s_Contact_us_for_support')}
          />
        </NoSSR>
      </div>
    </div>
  );
};

export default Maintenance;
